import useProgramCodes from './useProgramCodes';

const useProgramCodesActive = () => {
  const programCodes = useProgramCodes();
  return programCodes.filter(programCode => programCode.isActive);
};

export default useProgramCodesActive;
